import { Box, Grid, Typography } from '@mui/material';
import ImageValidator from 'components/ux/ImageValidator';
import { useState } from 'react';
import VideoText from './VideoText';

function HelpAndSupportComponent(props) {
  const [playFirst] = useState(1);
  return (
    <Grid container width={'100%'} height={'100%'}>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <Grid container width={'100%'}>
          <Grid item width={'100%'} textAlign={'center'}>
            <Typography sx={{ fontSize: '30px', fontWeight: '900' }}>{props.heading}</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <Grid container style={{marginTop:'20px'}} alignItems={'center'} spacing={1}>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <Grid container width={'100%'}>
              <Grid item width={'100%'} textAlign={'start'}>
                <Grid container width={'100%'}>
                  <Grid item width={'100%'}>
                    <VideoText
                      icon={props.icon1}
                      paragraphHeading={props.paragraphHeading1}
                      paragraph={props.paragraph1}
                    ></VideoText>
                  </Grid>
                  <Grid item width={'100%'}>
                    <VideoText
                      icon={props.icon2}
                      paragraphHeading={props.paragraphHeading2}
                      paragraph={props.paragraph2}
                    ></VideoText>
                  </Grid>
                  <Grid item width={'100%'}>
                    <VideoText
                      icon={props.icon3}
                      paragraphHeading={props.paragraphHeading3}
                      paragraph={props.paragraph3}
                    ></VideoText>
                  </Grid>
                  <Grid item width={'100%'}>
                    <VideoText
                      icon={props.icon4}
                      paragraphHeading={props.paragraphHeading4}
                      paragraph={props.paragraph4}
                    ></VideoText>
                  </Grid>
                  <Grid item width={'100%'}>
                    <VideoText
                      icon={props.icon5}
                      paragraphHeading={props.paragraphHeading5}
                      paragraph={props.paragraph5}
                    ></VideoText>
                  </Grid>
                  <Grid item width={'100%'}>
                    {props.paragraph6 ? (
                      <VideoText
                        icon={props.icon6}
                        paragraphHeading={props.paragraphHeading6}
                        paragraph={props.paragraph6}
                      ></VideoText>
                    ) : (
                      ''
                    )}
                  </Grid>
                  <Grid item width={'100%'}>
                    {props.paragraphHeading7 ? (
                      <VideoText
                        icon={props.icon7}
                        paragraphHeading={props.paragraphHeading7}
                        paragraph={props.paragraph7}
                      ></VideoText>
                    ) : (
                      ''
                    )}
                  </Grid>
                  <Grid item width={'100%'}>
                    {props.paragraphHeading8 ? (
                      <VideoText
                        icon={props.icon8}
                        paragraphHeading={props.paragraphHeading8}
                        paragraph={props.paragraph8}
                      ></VideoText>
                    ) : (
                      ''
                    )}
                  </Grid>
                  <Grid item width={'100%'}>
                    {props.paragraphHeading9 ? (
                      <VideoText
                        icon={props.icon9}
                        paragraphHeading={props.paragraphHeading9}
                        paragraph={props.paragraph9}
                      ></VideoText>
                    ) : (
                      ''
                    )}
                  </Grid>
                  <Grid item width={'100%'}>
                    {props.paragraphHeading10 ? (
                      <VideoText
                        icon={props.icon10}
                        paragraphHeading={props.paragraphHeading10}
                        paragraph={props.paragraph10}
                      ></VideoText>
                    ) : (
                      ''
                    )}
                  </Grid>
                  <Grid item width={'100%'} style={{ marginTop: '20px' }}>
                    <Grid container width={'100%'}>
                      <Grid item>
                        <Typography style={{ fontSize: '16px' }}> {props.bottomLine}</Typography>
                      </Grid>
                      <Grid item>
                        <img alt=""
                          src={props.bottomLineIcon}
                          style={{ width: '16px', marginTop: '3px', marginLeft: '10px' }}
                        ></img>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <Grid container justifyContent={'center'} alignItems={'center'}>
              <Grid item>
                <Box
                  style={{
                    width: '100%',
                    height: '100%',
                    border: '5px solid #000',
                    borderRadius: '5px',
                  }}
                >
                  {playFirst === 1 ? (
                    <ImageValidator
                      showMyVideo={true}
                      className="help-support-video"
                      url={props.videoUrl}
                    ></ImageValidator>
                  ) : (
                    'another video'
                  )}
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default HelpAndSupportComponent;
